import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

import { MEMBER_TYPES } from './constants'
import { type MemberType } from './types'

export interface MemberTypeGuideDialogProps {
  open: boolean
  onClose: VoidFunction
}

export const MemberTypeGuideDialog = ({ open, onClose }: MemberTypeGuideDialogProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Member Types</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            This dialog explains the three member types: Super Admin, Admin, and User, along with their respective
            permissions and responsibilities.
          </DialogDescription>
        </DialogHeader>

        <div className={cn('text-[14px] font-normal leading-[24px]')}>
          <p className={cn('mb-4')}>
            There are three types of members: <b>Super Admin</b>, <b>Admin</b>, and <b>User</b>.
          </p>

          <MemberTypeExplanation memberTypes={MEMBER_TYPES} />
        </div>
      </DialogContent>
    </Dialog>
  )
}

const MemberTypeExplanation = ({ memberTypes }: { memberTypes: MemberType[] }) => {
  return (
    <dl className={cn('space-y-3')}>
      {memberTypes.map(({ type, content }, index) => (
        <div
          key={index}
          className={cn('flex', 'pb-3', '[&:not(:last-of-type)]:border-b [&:not(:last-of-type)]:border-b-gray-200')}
        >
          <dt className={cn('mr-2.5 min-w-[100px]')}>
            <b>{type}</b>
          </dt>
          <dd>{content}</dd>
        </div>
      ))}
    </dl>
  )
}
